// extracted by mini-css-extract-plugin
export default {"suspense":"SuspenseFallback_suspense__ZxN63","full-height":"SuspenseFallback_full-height__fu8pZ"};